import { z } from "zod";

// Shared zod schema for the site-config form (Settings + Setup step 3).
// Secret keys are write-only: empty string means "leave unchanged".
export const siteConfigSchema = z.object({
  siteName: z.string().min(1, "Required").max(80),
  streamEndGraceMinutes: z.coerce
    .number()
    .int("Must be a whole number")
    .min(0, "Cannot be negative")
    .max(120, "Too large"),
  recordingRetentionDays: z.coerce
    .number()
    .int("Must be a whole number")
    .min(1, "At least 1 day")
    .max(3650, "Too large"),
  s3Endpoint: z.string().optional(),
  s3Region: z.string().optional(),
  s3Bucket: z.string().optional(),
  s3PublicAssetBase: z.string().optional(),
  s3AccessKey: z.string().optional(),
  s3SecretKey: z.string().optional(),
});

export type SiteConfigForm = z.infer<typeof siteConfigSchema>;
